import PropTypes from 'prop-types'
import styled from 'styled-components'

const Styled = styled.div`

  .highlight {
    color: #C21110;
  }

  .pizza-card {
    background-image: url(${props => props.bgimage});
    background-size: cover;
    height: 393px;
    padding-top: 25px;
    padding-bottom: 25px;
    border-radius: 12px;
    .sc-img {
      min-height: 153px;
    }
  }
  .pizza-card-details {
    // background-image: url(${props => props.bottombgimage});
    background-color: ${props => props.benefitsBgColor};
    background-size: cover;
    border-radius: 12px;
    margin-top: 15px;
    padding-bottom: 10px;
  }

  .bg-wildsand {
    background: #F4F4F4;
  }

  .bg-yellow-sea {
    background: #FFB106;
  }

  .bg-mine-shaft {
    background: #303030;
  }

  .pizza-card-footer {
    margin-top: 25px;
    .ant-col {
      .ant-btn-danger {
        border-top-left-radius: 0px !important;
        border-top-right-radius: 0px !important;
      }
    }
    .ant-btn[disabled] {
      background: #DCDCDC;
    }
  }

  .img-absolute {
    position: absolute;
  }

  .right-0 {
    right: 0;
  }
`

export const StyledSuperCard = ({ bgimage, bottombgimage, benefitsBgColor, children }) => {
  return (<Styled bgimage={bgimage} bottombgimage={bottombgimage} benefitsBgColor={benefitsBgColor}>{children}</Styled>)
}

StyledSuperCard.propTypes = {
  children: PropTypes.any,
  bgimage: PropTypes.any,
  bottombgimage: PropTypes.any,
  benefitsBgColor: PropTypes.string
}

export const StyledNotes = styled.div`
  font-size: 12px;
  color: #fff;
  &:before {
    content: '*'
  }
`
